export const title = 'How to Learn Your Harmony Part';

export function YourHarmonyPartTutorial() {
  return <div>{title}</div>;
}
